<template>
  <div class="jin-notice jin-side-notice">
    <div class="jin-side-notice__item">
      <h3 class="jin-side-notice__h">
      《金十交易现场》英文-中文同声传译
      </h3>
      <div
      class="jin-side-notice__countdown"
      v-if="countdownTime && !isLive">
        <icon type="countdown"></icon>
        <span>距离下一个节目直播还有 </span>
        <span>{{ countdownTime }}</span>
      </div>
      <div class="jin-side-notice__time">
        <h4 class="jin-side-notice__title is-inline">直播时间</h4>
        <p v-if="datas.date">{{ datas.date | dateFormat('yyyy年MM月dd日hh:mm:ss') }}（北京时间）</p>
      </div>
    </div>
    <!-- 出场人物 -->
    <div class="jin-side-notice__item">
      <div class="jin-side-notice__figure">
        <h4 class="jin-side-notice__title">本次讲话出场人物</h4>
        <ul class="jin-side-notice__list">
          <li
          class="jin-side-notice__imgText is-inline"
          v-for="(name, index) in datas.guest"
          :key="index">
            <img :src="`//tv.jin10.com/assets/img/trading/figure/${name}.jpg`" alt="">
            <span>{{ name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 主题介绍 -->
    <div class="jin-side-notice__item">
      <div class="jin-side-notice__intro">
        <h4 class="jin-side-notice__title">当前节目主题介绍</h4>
        <p>{{ datas.memo }}</p>
      </div>
    </div>
    <!-- 传译员 -->
    <div
    class="jin-side-notice__item"
    v-if="datas.interpreter">
      <div
      class="jin-side-notice__figure">
        <h4 class="jin-side-notice__title">Ta正在为您同传</h4>
        <ul class="jin-side-notice__list">
          <li
          v-for="(name, index) in datas.interpreter"
          :key="index"
          class="jin-side-notice__imgText is-inline">
            <img :src="`//tv.jin10.com/assets/img/trading/interpreter/${name}.png`" alt="">
            <span>{{ name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 栏目介绍 -->
    <div class="jin-side-notice__item">
      <div class="jin-side-notice__intro">
        <h4 class="jin-side-notice__title">栏目介绍</h4>
        <p>我们是金十小黑屋同传，致力于为您提供美联储主席鲍威尔、欧洲央行行长德拉基、“债王”格罗斯、“股神”巴菲特等大佬讲话的现场直播。交易世界，分秒必争，来交易现场体验没有时差阻隔、没有语言障碍的同传直播。</p>
      </div>
    </div>
    <!-- 公众号 -->
    <div class="jin-side-notice__item">
      <div class="jin-side-notice__qrcode">
        <p>请关注我们的公众号（仅面向专业用户）</p>
        <img src="//tv.jin10.com/assets/img/trading/jiaoyuwechat.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetch } from '@/commons/fetch'
import { requestUrl } from '@/commons/config'

export default {
  name: '',
  computed: {
    ...mapGetters([
      'tradingVideoID',
      'prevueTime',
      'serverTime',
      'isLive'
    ])
  },
  data () {
    return {
      datas: {},
      isLoading: false,
      countdownTime: '',
      timer: null,
      inited: false,
      loaded: false
    }
  },
  watch: {
    tradingVideoID (v) {
      if (v) {
        this.getNotice(v)
      }
    },
    prevueTime (v) {
      if (v && !this.inited) {
        this.countdown()
        this.inited = true
      }
    },
    $route () {
      this.$store.dispatch('setTradingVideoID', 0)
    }
  },
  mounted () {
    setTimeout(() => {
      if (!Object.keys(this.datas).length) {
        this.getNotice(this.tradingVideoID)
      }
    }, 1000)
  },
  methods: {
    getNotice (id) {
      fetch({
        type: 'jsonp',
        url: requestUrl.detail,
        params: {
          id
        },
        callback: () => {
          this.isLoading = false
        },
        success: ({ data }) => {
          this.datas = data
          this.$nextTick(() => {
            this.$emit('update')
          })
        },
        error: () => {
          this.isLoading = false
        }
      })
    },
    freshTime (endtime) {
      endtime = new Date(endtime) // 结束时间
      let nowtime = new Date() // 当前时间
      let lefttime = parseInt((endtime.getTime() - nowtime.getTime()) / 1000)
      let time = ''
      let d = parseInt(lefttime / 24 / 60 / 60)
      let h = parseInt((lefttime / (60 * 60)) % 24)
      let m = parseInt(lefttime / 60 % 60)
      let s = parseInt(lefttime % 60)
      if (s < 10) {
        s = '0' + s
      }
      time = `${d ? `${d}天` : ''}${h}小时${m}分${s}秒`
      if (lefttime <= 0) {
        clearInterval(this.timer)
        time = ''
      }
      this.countdownTime = time
    },
    countdown () {
      this.timer = setInterval(() => {
        this.freshTime(this.prevueTime.replace(/-/g, '/'))
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TradingNotice.vue?830410c4